<template>
  <div class="buyhtml">
    <div class="buyall">
      <div class="buyhead">
        <div class="buyheadtext">
          <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
           购买
          </p>
        </div>
      </div>
      <div class="buybody">
        <div class="bodytable">
          <div class="buytips">
            <p style="text-align: center; font-weight: bold">软件服务费</p>
            <div class="buytable">
              <div style="color:black">一、套餐功能列表</div>
             <table class="table1">
              <tr><th align="center" colspan="2">类别</th><th style="width:610px;"  align="center">功能</th><th style="width:82px;padding:10px 0" align="center">7E个人版</th><th style="width:101px;padding:10px 0" align="center">7C机构版<br>套利工具</th></tr>
              <tr><td rowspan="3" style="width:40px"><div style="width:20px;margin:0 auto;line-height:20px;">价格研究</div></td><td style="width:130px;text-align:center"><router-link to="/proc/productcenterjgyj/xwyb" target="_blank">小文研报</router-link><img src="../../assets/images/huohuo.png"  class="imghuo"></td><td class="midtxt">7*24小时的专业商品研究报告</td><td>√</td><td>√</td>
              </tr>
              <tr>
                
                <td><router-link to="/proc/productcenterjgyj/gzx" target="_blank">小文估值</router-link></td><td class="midtxt">50个商品和4个股指期货的估值数据、估值线图表、估值上限、估值下限</td><td>√</td><td>√</td>
                </tr>
              <tr><td><router-link to="/proc/productcenterjgyj/kzfx" target="_blank">扩展分析</router-link></td><td class="midtxt">回归分析、波动率分析、季节性分析、期货横截面、期现链</td><td>√</td><td>√</td></tr>
              
              <tr><td rowspan="4"><div style="width:20px;margin:0 auto;line-height:20px;">策略交易</div></td><td style="text-align:center"><router-link to="/proc/productcenterzyjy/tljy" target="_blank">套利交易</router-link></td><td class="midtxt">自由设置套利对，套利k线图、价差周期性、二腿价格走势百分比图、二腿相关度、<br>二腿价格走势图、价差分布图，套利一键下单、套利价差挂单交易、套利分批下单、<br>套利下单任务管理，支持多账号套利<sup>*1</sup><img src="../../assets/images/huohuo.png"  class="imghuo">、内外盘套利交易。套利算法交易辅助</td><td style="font-size: 24px;">-</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterzyjy/ycjy" target="_blank">移仓交易</router-link></td><td class="midtxt">自由设置移仓配对、移仓k线图历史数据、移仓价差成交量统计<img src="../../assets/images/huohuo.png"  class="imghuo">、移仓量指标<img src="../../assets/images/huohuo.png"  class="imghuo">，<br>移仓价差挂单交易<img src="../../assets/images/huohuo.png"  class="imghuo">、移仓分批下单、移仓下单任务管理，支持多账号移仓<sup>*1</sup><img src="../../assets/images/huohuo.png"  class="imghuo">。<br>移仓算法交易辅助</td><td style="font-size: 24px;">-</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterzyjy/wgjy" target="_blank">网格交易</router-link><img src="../../assets/images/huohuo.png"  class="imghuo"></td><td class="midtxt">单向网格策略、固定网格策略</td><td>√</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterzyjy/qqjy" target="_blank">期权组合策略</router-link><img src="../../assets/images/huohuo.png"  class="imghuo"></td><td class="midtxt">垂直套利、跨式套利、备兑套利、水平套利、合成标的、自组策略、风险分析、<br>组合条件单、组合风控单、组合价格预警、趋势下单、成交统计</td><td>√</td><td>√</td></tr>

              <tr><td rowspan="3"><div style="width:20px;margin:0 auto;line-height:20px;">下单工具</div></td><td style="text-align:center"><router-link to="/proc/productcenterxgj/fpxd" target="_blank">算法分批下单</router-link></td><td class="midtxt">小鬼插队期货专用算法，持续对手价、持续排队价、诱饵挂单、TWAP、幽灵、<br>随机冰山、高效冰山</td><td>√</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterxgj/rwglq" target="_blank">下单任务管理器</router-link></td><td class="midtxt">监控多个下单任务、算法分批下单</td><td>√</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterxgj/wjxd" target="_blank">文件下单</router-link></td><td class="midtxt">定时扫描下单文件、分批下单</td><td>√</td><td>√</td></tr>

              <tr><td rowspan="2"><div style="width:20px;margin:0 auto;line-height:20px;">其他</div></td><td style="text-align:center"><router-link to="/proc/productcenterqtgn/qsxyj" target="_blank">云端预警</router-link><img src="../../assets/images/huohuo.png"  class="imghuo"></td><td class="midtxt">云端趋势线预警、云端公式预警</td><td>√</td><td>√</td></tr>
              <tr><td><router-link to="/proc/productcenterqtgn/yjdp" target="_blank">一机多屏</router-link><img src="../../assets/images/huohuo.png"  class="imghuo"></td><td class="midtxt">自设页面分屏、多屏幕显示</td><td>√</td><td>√</td></tr>
              
              <tr><td colspan="3" style="text-align:right;line-height:35px;padding:5px;">以上打勾功能服务费(单位：元/年/账号)</td><td style="font-size:16px;font-weight:bold">{{webMarketPrice.price1}}</td><td style="font-size:16px;font-weight:bold">{{webMarketPrice.price2}}</td></tr>
            </table>
            <div style="color:black;margin-top:20px">二、选配付费数据/功能</div>
            <table class="table2">
              <tr><th style="width:160px"  align="center">类别</th><th style="width:450px;"  align="center">数据/功能</th><th style="width:260px;" align="center">价格（年/账号）</th></tr>
              <tr><td rowspan="24"   valign="middle" align="center"  style="text-align:center;padding-left:5px">行情数据模块<sup>*2</sup></td ><td class="midtxt">芝加哥期货交易所（CBOT）</td><td class="price">+{{filterid(143,'price')}}元 / {{filterid(143,'majorprice')}}元（专业用户）<span style="position:relative" ref="pop"><img src="../../assets/images/wenhgm.png"  class="imghuo"><Pop class="pop" v-show="showpop"></Pop></span></td></tr>
              <tr><td class="midtxt">芝加哥商品交易所（CME）</td><td class="price">+{{filterid(144,'price')}}元 / {{filterid(144,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">纽约商业交易所（NYMEX）</td><td class="price">+{{filterid(141,'price')}}元 / {{filterid(141,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">纽约商品交易所（COMEX）</td><td class="price">+{{filterid(142,'price')}}元 / {{filterid(142,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">欧洲期货交易所（EUREX）</td><td class="price">+{{filterid(291,'price')}}元（个人）<sup>*3</sup></td></tr>
              <!-- <tr><td class="midtxt">伦敦金属交易所（LME）</td><td class="price">+{{filterid(286,'price')}}元</td></tr> -->
              <tr><td class="midtxt">洲际交易所（ICE）- 美国</td><td class="price">+{{filterid(199,'price')}}元</td></tr>
              <tr><td class="midtxt">洲际交易所（ICE）- 欧洲商品</td><td class="price">+{{filterid(200,'price')}}元</td></tr>
              <tr><td class="midtxt">伦敦金属交易所LME电子盘（仅中国大陆、中国香港查看）</td><td class="price">+{{filterid(850,'price')}}元</td></tr>
              <tr><td class="midtxt">伦敦金属交易所LME（全球查看）</td><td class="price">+{{filterid(286,'price')}}元</td></tr>
              <tr><td class="midtxt">香港交易所期货（仅中国大陆内查看）</td><td class="price">+{{filterid(855,'price')}}元（个人） / {{filterid(855,'majorprice')}}元（公司）</td></tr>
              <tr><td class="midtxt">香港交易所期货（全球查看）</td><td class="price">+{{filterid(868,'price')}}元</td></tr>
              <tr><td class="midtxt">香港交易所股票（仅中国大陆内查看）</td><td class="price">+{{filterid(336,'price')}}元（个人） / {{filterid(336,'majorprice')}}元（公司）</td></tr>
              <tr><td class="midtxt">香港交易所股票（全球查看）</td><td class="price">+{{filterid(340,'price')}}元</td></tr>
              <tr><td class="midtxt">美国股票</td><td class="price">+{{filterid(84,'price')}}元</td></tr>
              <tr><td class="midtxt">全球外汇</td><td class="price">+{{filterid(378,'price')}}元</td></tr>
              <tr><td class="midtxt">伦敦金数据</td><td class="price">+{{filterid(83,'price')}}元</td></tr>
              <tr><td class="midtxt">上海黄金交易所数据（黄金T+D等）	</td><td class="price">+{{filterid(170,'price')}}元</td></tr>
              <tr><td class="midtxt">五档 - 大连商品交易所（DCE）</td><td class="price"><a class="wenhaogm" href="https://www.wenhua.com.cn/Home/ChargeDataDLEVEL2" target="_blank" style="border:none" >+{{filterid(79,'price')}}元/+{{filterid(78,'price')}}元（Level2）<img src="../../assets/images/wenhgm.png"  class="imghuo"></a></td></tr>
              <tr><td class="midtxt">五档 - 郑州商品交易所（ZCE）</td><td class="price">+{{filterid(81,'price')}}元</td></tr>
              <tr><td class="midtxt">五档 - 上海黄金交易所数据(黄金T+D等)</td><td class="price">+{{filterid(348,'price')}}元</td></tr>
              <tr><td class="midtxt">五档 - 芝加哥期货交易所（CBOT）</td><td class="price">+{{filterid(147,'price')}}元 / {{filterid(147,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 芝加哥商品交易所（CME）</td><td class="price">+{{filterid(148,'price')}}元 / {{filterid(148,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 纽约商业交易所（NYMEX）</td><td class="price">+{{filterid(145,'price')}}元 / {{filterid(145,'majorprice')}}元（专业用户）</td></tr>
              <tr><td class="midtxt">五档 - 纽约商品交易所（COMEX）</td><td class="price">+{{filterid(146,'price')}}元 / {{filterid(146,'majorprice')}}元（专业用户）</td></tr>
              <tr><td rowspan="7"   valign="middle" align="center" style="text-align:center;padding-left:5px;line-height:19px"><div>多账号下单模块</div><div><router-link to="/proc/productcenterxgj/dzh" target="_blank" class="linkjieshao">查看介绍</router-link></div></td ><td class="midtxt">一带多下单<img src="../../assets/images/huohuo.png"  class="imghuo"></td><td rowspan="7"   valign="middle" align="center" class="price">+{{filterid(284,'price')}}元</td></tr>
              <tr><td class="midtxt">账号分组<img src="../../assets/images/huohuo.png"  class="imghuo"></td></tr>
              <tr><td class="midtxt">组中账号设置不同下单倍数<img src="../../assets/images/huohuo.png"  class="imghuo"></td></tr>
              <tr><td class="midtxt">云端分组止损止盈</td></tr>
              <tr><td class="midtxt">云端分组画线下单</td></tr>
              <tr><td class="midtxt">云端分组条件单</td></tr>
              <tr><td class="midtxt">账户风控</td></tr>
              
            </table>
            </div>
          </div>
        </div>
      </div>
      <div class="tipsss">
        <!-- <p class="zhushi" style="margin-bottom: 25px">
          4.如需在境外查看中金一档数据，需另外付数据使用费。
        </p> -->
         <p class="zhu">注&nbsp;:</p>
        <p class="zhushi" style="text-indent:0">
          *1.多账号相关功能需另外付费；
        </p>
        <p class="zhushi" style="text-indent:0">
          *2.选配数据是指在标配数据以外可选择增加的数据授权，选配数据需另外支付相应费用(费用单位：元/年/账号)；
        </p>
        <p class="zhushi" style="margin-bottom:13px;text-indent:0">
          *3.欧洲期货交易所570元/年/终端的价格只针对中国境内个人用户购买有效。
        </p>
        <p style="border-bottom: 1px solid #e7eafc"></p>
        <p style="margin-top: 13px">
          <img src="../../assets/images/zhuyi.png" /><span
            class="zhushi"
            style="padding-left: 3px"
            >声明:</span
          >
        </p>
        <p class="zhushi">
          1.按照监管新规，新客户必须报备通过以后才能程序化交易，请先向期货公司报备，再购买软件;
        </p>
        <p class="zhushi" style="text-indent:2em; margin-top: -5px;">
          登录软件后，在菜单 系统工具－>程序化报备，也可向部分期货公司报备。
        </p>
        <p class="zhushi">
          2.本服务必须提供的数据、信息、功能仅限用户另外付费选配的范围，服务期内我司有权对其他数据、信息、功能进行增减等调整；
        </p>
        <p class="zhushi">
          3.你可能遇到的下列情形(包括但不限于)恕我司不负责解决，并不退还剩余费用：
        </p>
        <p class="zhushi">
          (1)因电脑硬件配置低或操作系统版本过低，无法满足新版要求；
        </p>
        <p class="zhushi">(2)开户的期货公司，不再支持文华软件。</p>
        <div class="lianjie">
          <div style="display: inline-block;float: left;margin-left: 1em;color:#5a5a5a;position: absolute;left: 0px;bottom: 39px;font-size:14px">咨询电话：<common-data name="serviceTel"/></div>
          <div class="buylianjie">
            <a
              style="
                color: white;
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 1px;
              "
              href="https://pay.wenhua.com.cn/#/detail/76"
              target="_blank"
              >去购买</a
            >
          </div>
          <a
            style="
              text-decoration: none;
              color: #304560;
              position: relative;
              bottom: -8px;
              font-size: 12px;
              border-bottom: 2px solid black;
              letter-spacing: 1px;
            "
            href="https://pay.wenhua.com.cn/#/question"
            target="_blank"
          >
            购买相关常见问题</a
          >
        </div>
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import axios from 'axios'
import  Pop from './components/Pop.vue'
export default {
  data() {
    return {
      lefttext: [false, false],
      setTime:'',
      isclick: "imgbuy",
      noclick: "imgbuy1",
      righttext: {
        righttext1: false,
        righttext2: false,
        righttext3: false,
        righttext4: false,
        righttext5: false,
      },
      showpop:false,
      showpop2:false,
      webMarketPrice:{
        price1:0,
        price2:0,
        sublist:[],
      },
    };
  },
  components: {
    wh7footer,
  },
  methods: {
    setPrice(){
      axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=76').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price1 = res.data.data.price
            this.webMarketPrice.sublist = res.data.data.sublist
          } else {
            alert(res.data.message)
          }
        });
        axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=123').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price2 = res.data.data.price
            
          } else {
            alert(res.data.message)
          }
        });
    },
    filterid(id,str){
        return  !!this.webMarketPrice.sublist.filter((el)=>{
          return el.id == id
        })[0]?this.webMarketPrice.sublist.filter((el)=>{
          return el.id == id
        })[0][str]:''
    },
    custormAnchor(anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      console.log(anchorElement)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },
    clickleft(num) {
      this.lefttext[num] = !this.lefttext[num];
      if (num == 0) {
        this.lefttext[1] = false;
      } else {
        this.lefttext[0] = false;
      }

      this.$forceUpdate();
      // if (this.lefttext == false) {
      //   document.getElementsByClassName("buyleftdown")[0].style.textAlign =
      //     "center";
      // } else {
      //   document.getElementsByClassName("buyleftdown")[0].style.textAlign =
      //     "right";
      // }
    },
     showP(e){
      if(this.$refs.pop.contains(e.target)){
        clearTimeout(this.setTime)
        this.setTime=''
        this.showpop=true
      }
      else if(this.$refs.pop2.contains(e.target)){
        clearTimeout(this.setTime)
        this.setTime=''
        this.showpop2=true
      }
      else{
        if(!!this.setTime){
          return
        }
        this.setTime = setTimeout(()=>{this.showpop=false,this.showpop2=false},300)
      }
    },
    bianli() {
      Object.keys(this.righttext).forEach((item) => {
        this.righttext[item] = false;
      });
    },
    rightclickfirst() {
      //       console.log(Object.getOwnPropertyNames(this.righttext).length)
      // for(var count=0;count<this.righttext.length;count++){
      //   if(count==0){
      //     this.righttext.righttext1=!this.righttext.righttext1

      //   }
      //   else{
      //     console.log(1)
      //     this.righttext[count]=false
      //   }
      // }
      Object.keys(this.righttext).forEach((item, index) => {
        if (index == 0) {
          this.righttext.righttext1 = !this.righttext.righttext1;
        } else {
          this.righttext[item] = false;
        }
      });
    },
    rightclicksecond() {
      Object.keys(this.righttext).forEach((item, index) => {
        if (index == 1) {
          this.righttext.righttext2 = !this.righttext.righttext2;
        } else {
          this.righttext[item] = false;
        }
      });
    },
    rightclickthird() {
      Object.keys(this.righttext).forEach((item, index) => {
        if (index == 2) {
          this.righttext.righttext3 = !this.righttext.righttext3;
        } else {
          this.righttext[item] = false;
        }
      });
    },
    rightclickfouth() {
      Object.keys(this.righttext).forEach((item, index) => {
        if (index == 3) {
          this.righttext.righttext4 = !this.righttext.righttext4;
        } else {
          this.righttext[item] = false;
        }
      });
    },
    rightclickfifth() {
      // Object.keys(this.righttext).forEach((item, index) => {
      //   if (index == 4) {
      //     this.righttext.righttext5 = !this.righttext.righttext5;
      //   } else {
      //     this.righttext[item] = false;
      //   }
      // });
      
          window.open('https://minitms.wenhua.com.cn')
    },
  },
  mounted() {
    console.log(this.$route.params.id)
    this.custormAnchor(this.$route.params.id);
  },
  created(){
    window.addEventListener('mousemove',this.showP)
    this.setPrice()
  },
  beforeRouteLeave(to, from, next)  {
    window.removeEventListener('mousemove',this.showP)
    next()
  }
};
</script>

<style scoped>
.pop {
  position: absolute;
  left: 20px;
  top: 0px;
}
.buyhtml {
  background: #f8fbff;
  min-width: 1400px;
  width: 100%;
  background-size: auto 1000px;
  min-height: 835px;
  z-index: 3;
  margin: 0 auto;
}
.buyall {
  min-width: 1400px;
  width: 100%;
  background: url("../../assets/images/11111.jpg") no-repeat top;

  min-height: 835px;
  z-index: 10;
}
.buyhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.buyheadtext {
  position: absolute;
  top: 100px;
}
.buybody {
  width: 996px;
  margin: 0 auto;
  min-height: 0;
  background: white;
  /* margin-top: 9px; */
}
td {
  /* border: 0; */
  text-align: left;
  padding-left: 2px;
  color: #7d4c3d;
  padding-right: 5px;
  padding-left: 2px;
  height: 28px;
  line-height: 28px;
}
.bodytable {
  width: 996px;
  margin: 0 auto;
  /* background: url("../../assets/images/wh.png") no-repeat top; */
}
.midtxt {
  padding-left: 15px;
  letter-spacing: 0.5px;
}
.rigtxt {
  background: #faf5ef;
}
br {
  height: 0px;
}
.zhu {
  /* background: url("../../assets/images/zhu.png") no-repeat; */
  margin-top: 20px;
  color: white;
  padding-left: 7px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #898989;
  letter-spacing: 1px;
  text-indent: 1em;
}
.lianjie {
  margin-top: 60px;
  padding-bottom: 60px;
  text-align: right;
  width: 972px;
}
.buylianjie {
  background: url("../../assets/images/buy.png") no-repeat center;
  display: inline-block;
  width: 150px;
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
  text-align: center;
}
a {
  color: #7d4c3d;
  text-decoration: none;
  width: 180px;
}
.price {
  padding-left: 10px;
  letter-spacing: 0.1px;
}
.xuanpei {
  background: #e8d3b4;
  text-align: center;
  font-weight: bold;
  font-size: 15px;
}
.buytips {
  min-height: 40px;
  height: 100%;
  font-size: 18px;
  line-height: 40px;
  color: white;
  letter-spacing: 2px;
  font-weight: 540;
}
.buytable {
  position: relative;
  height: 100%;
  min-height: 180px;
  width: 980px;
  /* background: #faf8f3; */
}
.buyleft {
  vertical-align: top;
  margin-top: 0px;
  width: 503px;
  color: #93694a;
  display: inline-block;
  text-align: center;
}
.buyleftdown {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 55px;
}
.imgbuy {
  background: url("../../assets/images/jiantouxia.png") no-repeat center;
}
.lefttable {
  width: 436px;
  margin-top: 40px;
}
.buytabletitle {
  width: 436px;
  /* background: #f3e6c9; */
  color: #93694a;
  text-align: left;
  padding-left: 5px;
}
.imgbuy1 {
  background: url("../../assets/images/jiantoushang.png") no-repeat center;
}
.imgs {
  display: inline-block;
  margin-left: 8px;
  margin-bottom: 7px;
  cursor: pointer;
  width: 13px;
  height: 10px;
}
.buymid {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 483px;
  margin: 15px 15px 15px 15px;
  display: inline-block;
  width: 10px;
  border-left: 1px solid #e4d7b9;
}
.buyright {
  display: inline-block;
  width: 412px;
  min-height: 180px;
}
.buyrighttext {
  color: #93694a;
  font-size: 14px;
  /* font-weight: bold; */
  line-height: 24px;
  margin-top: 3px;

  height: 24px;
}
.buyrightleft {
  float: left;
}
.buyleftleft {
  float: right;
}
.imgri {
  padding-bottom: 10px;
}
.tipsss {
  width: 996px;
  margin: 0 auto;
}
.midjiahao {
  position: absolute;
  left: -20px;
  top: 45px;
}
.csssanjiao {
  margin-top: 2px;
  height: 0;
  width: 0;
  border-bottom: 10px solid #fff5e0;
  border-right: 8px solid #faf8f3;
  border-left: 8px solid #faf8f3;
  margin-left: 70px;
  box-shadow: 2px -1px 16px #f2e0bc inset;
}
.sanjiaotext {
  box-shadow: 2px -1px 2px #f2e0bc inset, -2px 0px 5px #f2e0bc inset;
  background: #fff5e0;
  width: 412px;
  margin-top: 15px;
}
.buythree {
  width: 400px;
  background: #ffecc2;
  color: #93694a;
  position: relative;

  height: 30px;
}
.buythree p {
  line-height: 30px;
  height: 30px;
  font-size: 14px;
}
.threeleft {
  position: absolute;
  left: 10px;
}
.threeright {
  position: absolute;
  right: 0;
}
.threehiright {
  position: absolute;
  right: 0;
  height: 65px;
  width: 200px;
  border-left: 1px solid #fffdf8;
  font-size: 14px;
}
.threehiritop {
  border-bottom: 1px solid #fffdf8;
  height: 24px;
  text-align: center;
  line-height: 24px;
}
.threehiright p {
  text-align: center;
  line-height: 24px;
}
.sanjiao {
  margin-left: 70px;
  margin-bottom: -15px;
}
.sanjiaoleft {
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg); /* IE 9 */
  -moz-transform: rotate(45deg); /* Firefox */
  -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
  -o-transform: rotate(45deg); /* Opera */
  background: #fff5e0;
  position: absolute;
  box-shadow: 2px -1px 2px #f2e0bc inset;
}
.sanjiaoright {
  width: 13px;
  height: 13px;
  transform: rotate(135deg);
  -ms-transform: rotate(135deg); /* IE 9 */
  -moz-transform: rotate(135deg); /* Firefox */
  -webkit-transform: rotate(135deg); /* Safari 和 Chrome */
  -o-transform: rotate(135deg); /* Opera */
  background: #fff5e0;
  position: absolute;
  top: -6px;
  left: 70px;
  box-shadow: 2px -1px 2px #f2e0bc inset;
}

.titlexp {
  background: #ffe5aa;
  font-size: 14px;
  color: #9b755a;
  margin: 5px 5px 0 5px;
  line-height: 34px;
  height: 34px;
}
.titlexp span {
  display: inline-block;
  text-align: center;
}
.atiaozhuan {
  text-decoration: underline #bd9386;
}
.buyright a {
  text-decoration: underline #bd9386;
}
.xuqiu {
  text-align: left !important;
  padding-left: 8px !important;
}
.combo_name {
  color: #717b8a;
  font-size: 14px;
  border-bottom: 1px solid #c0c4ca;
  width: 503px;
}
.combo_name.active {
  color: #8395c6;
}
.combo_name div {
  display: inline-block;
  width: 168px;
  text-align: center;
  height: 78px;
  line-height: 78px;

  vertical-align: top;
}
.combo_name div:last-child {
  width: 167px;
  /* border-bottom: 1px solid  #f5d9b0;  */
}
.combo_name div:first-child {
  font-size: 16px;
}
.midtxt {
  padding-left: 10px;
  letter-spacing: 0.5px;
}
.table2 .midtxt{
  padding-left: 10px;
}
.rigtxt {
  background: #faf5ef;
}
br {
  height: 0px;
}
.zhu {
  /* background: url("../../assets/images/zhu.png") no-repeat; */
  margin-top: 20px;
  color: #5a5a5a;
  padding-left: 0px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #5a5a5a;
  letter-spacing: 1px;
  text-indent: 1em;
}
.lianjie {
  margin-top: 60px;
  padding-bottom: 30px;
  text-align: right;
  width: 972px;
  position: relative;
}
.buylianjie {
  background: url("../../assets/images/buy.png") no-repeat center;
  display: inline-block;
  width: 150px;
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
  text-align: center;
}
a {
  color: #7d4c3d ;
  text-decoration: none;
  width: 180px;
}
.price {
  padding-left: 10px;
  letter-spacing: 0.1px;
}
.xuanpei {
  background: #e8d3b4;
  text-align: center;
  font-weight: bold;
  font-size: 15px;
}
.buytable {
  position: relative;
  height: 100%;
  min-height: 150px;
  width: 900px;
  padding-bottom: 16px;
  margin: 0 auto;
  /* background: #faf8f3; */
}
.buyleft {
  vertical-align: top;
  margin-top: 0px;
  /* width: 520px; */
  margin-left: 42px;
  color: #93694a;
  /* border-right: 1px solid #f5d9b0; */
  display: inline-block;
  /* padding-left: 30px; */
  /* text-align: center; */
}
.buyleftdown {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 45px;
}
.buylefttop {
  /* padding-left: 30px; */
  font-size: 18px;
}
.lefttable {
  width: 100%;
  background: rgb(250, 246, 237);
  border-bottom: 2px #e9dbb8 solid;
  /* margin-top: 40px; */
}
.lefttable table {
  width: 100%;
}
.buytabletitle {
  width: 480px;
  /* background: #f3e6c9; */
  color: #93694a;
  text-align: left;
  padding-left: 5px;
}
.imgs {
  display: inline-block;
  margin-left: 8px;
  margin-right: 45px;
  margin-top: 10px;
  cursor: pointer;
  width: 13px;
  height: 10px;
}
.buymid {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 520px;
  margin: 15px 15px 15px 15px;
  display: inline-block;
  width: 10px;
  border-left: 1px solid #e4d7b9;
}
.buyright {
  display: inline-block;
  width: 409px;
  /* min-height: 180px; */
  min-height: 121px;
  border-bottom: 1px solid #c0c4ca;
  /* padding: 0 15px; */
  padding-bottom: 14px;
}
.buyrighttext {
  color: #717b8a;
  font-size: 14px;

  line-height: 30px;

  height: 30px;
}
.buyrighttext.active {
  color: #8395c6;
}
.buyrightleft {
  float: left;
  padding-left: 45px;
}
.buyleftleft {
  float: right;
}

.midjiahao {
  position: absolute;
  left: -20px;
  top: 45px;
}
.csssanjiao {
  margin-top: 2px;
  height: 0;
  width: 0;
  border-bottom: 10px solid #fff5e0;
  border-right: 8px solid #faf8f3;
  border-left: 8px solid #faf8f3;
  margin-left: 70px;
  box-shadow: 2px -1px 16px #f2e0bc inset;
}
.sanjiaotext {
  box-shadow: 2px -1px 2px #f2e0bc inset, -2px 0px 5px #f2e0bc inset;
  background: #fff5e0;
  width: 100%;
  margin-top: 7px;
  margin-bottom: 10px;
}
.buythree {
  width: 400px;
  background: #ffecc2;
  color: #93694a;
  position: relative;

  height: 30px;
}
.buythree p {
  line-height: 30px;
  height: 30px;
  font-size: 14px;
}
.threeleft {
  position: absolute;
  left: 10px;
}
.threeright {
  position: absolute;
  right: 0;
}
.threehiright {
  position: absolute;
  right: 0;
  height: 65px;
  width: 200px;
  border-left: 1px solid #fffdf8;
  font-size: 14px;
}
.threehiritop {
  border-bottom: 1px solid #fffdf8;
  height: 24px;
  text-align: center;
  line-height: 24px;
}
.threehiright p {
  text-align: center;
  line-height: 24px;
}

.sanjiao {
  margin-left: 70px;
  margin-bottom: -15px;
}
.sanjiaoleft {
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg); /* IE 9 */
  -moz-transform: rotate(45deg); /* Firefox */
  -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
  -o-transform: rotate(45deg); /* Opera */
  background: #fff5e0;
  position: absolute;
  box-shadow: 2px -1px 2px #f2e0bc inset;
}
.sanjiaoright {
  width: 13px;
  height: 13px;
  transform: rotate(135deg);
  -ms-transform: rotate(135deg); /* IE 9 */
  -moz-transform: rotate(135deg); /* Firefox */
  -webkit-transform: rotate(135deg); /* Safari 和 Chrome */
  -o-transform: rotate(135deg); /* Opera */
  background: #fff5e0;
  position: absolute;
  top: -6px;
  left: 70px;
  box-shadow: 2px -1px 2px #f2e0bc inset;
}

.huohuo {
  margin-bottom: -5px;
}
.xuanpeitb {
  width: calc(100% - 15px);
  margin-left: 10px;
  margin-top: 7px;
  /* margin-bottom: 15px; */
  border-collapse: separate;

  background: #fff5e1;
}

.shangtxt {
  /* padding-top: 5px !important; */
}
.xiatxt {
  /* padding-bottom: 5px !important; */
  text-align: right;
}
.titlexp {
  background: #ffe5aa;
  font-size: 14px;
  color: #9b755a;
  margin: 5px 5px 0 5px;
  line-height: 34px;
  height: 34px;
}
.titlexp span {
  display: inline-block;
  text-align: center;
}
.atiaozhuan {
  text-decoration: underline #bd9386;
}
.buyright a {
  text-decoration: underline #bd9386;
}
.xuqiu {
  text-align: left !important;
  padding-left: 8px !important;
}
.combo_div {
  margin: 30px 42px 0 42px;
  height: 30px;
  line-height: 30px;
  background: #8395c6;
}
.combo_div div {
  display: inline-block;
  text-align: center;
  font-size: 14px;
  width: 167px;
  border-right: 1px solid #fff;
  vertical-align: top;
  height: 20px;
  line-height: 20px;
  margin-top: 5px;
}
.combo_div div:last-child {
  border: none;
}
.zk {
  font-size: 12px;
  color: #3888ff;
  text-decoration: underline;
}
.combo_name {
  color: #717b8a;
  font-size: 14px;
  border-bottom: 1px solid #c0c4ca;
  width: 503px;
}
.combo_name.active {
  color: #8395c6;
}
.combo_name div {
  display: inline-block;
  width: 167px;
  text-align: center;
  height: 78px;
  line-height: 78px;

  vertical-align: top;
}
.combo_name div:last-child {
  width: 167px;
  /* border-bottom: 1px solid  #f5d9b0;  */
}
.combo_name div:first-child {
  font-size: 16px;
}
sup {
  font-size: 12px;
  position: relative;
  top: -5px;
}
th{
  padding: 10px;
  background:#193f63;
  line-height:19px;
  letter-spacing:1px;
  font-size:15px;
  vertical-align: middle;
}
.table1 tr td:last-child{
  text-align: center;
}
.table1 tr td:nth-last-child(2){
  text-align: center;
}
.table1 tr td:first-child{
  /* padding-left: 15px; */
  text-align: center;
}
.imghuo{
  margin-left: -4px;
}
/* .table1 a,.table2 a{
  text-decoration: underline;
} */
.linkjieshao{
  text-decoration: underline;
  color: blue;
  border: none !important;
}
.table1 a{
  /* text-decoration: underline !important; */
  border-bottom: 1px solid #7d4c3d;
}
.table1 a:hover{
  color: blue;
  border-bottom: 1px solid blue;
}
.table2 a{
  /* text-decoration: underline !important; */
  border-bottom: 1px solid #7d4c3d;
}
.table2 a:hover{
  color: blue;
  border-bottom: 1px solid blue;
}
.table1 tr th,.table2 tr th{
  border-right: 1px solid white;
}
/* .table1 tr td:nth-child(2){
  text-align: justify;
} */
.table1 tr th:last-child,.table2 tr th:last-child{
  border:none;
}
.table1 .midtxt{
  letter-spacing: 0;
}

a.wenhaogm:hover {
  color: #7d4c3d !important;
}
</style>